import type { ComponentPropsWithRef, ReactNode } from 'react';

import { Text, Title } from '~/components';
import { clsx } from '~/styles/utils';

import { headerStyle, headingStyle, sectionsStyle, sectionStyle } from './SettingsSection.css';

type SectionProps = Omit<ComponentPropsWithRef<'section'>, 'title'> & {
  action?: ReactNode;
  description?: ReactNode;
  title: ReactNode;
};

export const SettingsSection = ({ action, children, description, title, ...delegated }: SectionProps) => {
  return (
    <section {...delegated} className={clsx(sectionStyle, delegated.className)}>
      <div className={headerStyle}>
        <div className={headingStyle}>
          <Title as="h2" styleAs="h3">
            {title}
          </Title>

          {description && <Text>{description}</Text>}
        </div>

        {action}
      </div>

      {children}
    </section>
  );
};

export const SettingsSections = ({ children }: { children: ReactNode }) => <div className={sectionsStyle}>{children}</div>;
